import React from "react";
import Navbar from "../headers_footer/navbar";
import Flexproducts from "./flexproducts";
import Header from "../headers_footer/header";

const Perfume = () => {

return (

<div>

<Navbar />
<Flexproducts type="perfume" />
<Header></Header>

</div>

);
};

export default Perfume;